import DashboardWorkflowCard from "../../Dashboard/DashboardWorkflowCard";
import useFavorites from "../../Apps/Workflow/hooks/useFavorites";

export default function RecentProjectsGrid({ workflows, navigate, t }) {
    const { isFavorite, reloadFavorites } = useFavorites();
    return (
        <>
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-lg font-medium text-gray-700">
                    {t("chatPage.recentApps.title", { defaultValue: "Recent Projects" })}
                </h3>
                <button onClick={() => navigate("/workflows")} className="text-sm text-blue-600 hover:underline">
                    {t("chatPage.recentApps.viewAll", { defaultValue: "View all →" })}
                </button>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {workflows.map((wf) => (
                    <DashboardWorkflowCard
                        key={wf.id}
                        workflow={wf}
                        isFavorite={isFavorite(wf.id)}
                        onFavoriteChange={reloadFavorites}
                    />
                ))}
            </div>
        </>
    );
}
